import { commonConstants as cc } from 'srcReact/components'
import { subscriptionConstants as sc } from 'srcReact/SubscriptionPage'
import {
  isMobileScreen,
  isTabletScreen,
  isWideScreen,
  isNative,
  uuid,
  setCookie,
  deepEqual
} from 'srcReact/helpers/utils'
import { appConstantSettings } from 'srcReact/appConstantSettings'

const initialStates = {
  isMobile: isMobileScreen(),
  isTablet: isTabletScreen(),
  isDesktop: isWideScreen(),
  isNative: isNative(),
  v2AnnouncementStatus: -1,
  isPopinOpen: false,
  openedPopinName: '',
  fileCreation: {
    fileCount: 0,
    loadingFile: false,
    files: null,
    fileIds: '',
    draftFileIds: '',
    error: false
  },
  filesCreation: [
    //this is the array of below object
    // {
    // fileCount: 0,
    // loadingFile: false,
    // file: null,
    // fileIds: '',
    // draftFileIds: '',
    // error: false,
    // from: '',
    // messageObject: []
    // }
  ],
  landing: {
    submitted: false,
    success: false,
    error: false
  },
  notifications: {
    unread: 0,
    groups: [],
    mixrs: [],
    items: {}
  },
  messages: {
    unread: 0,
    items: {}
  },
  subscription: {
    rules: {
      userLimit: 0,
      workplaceLimit: 0
    }
  },
  managePaymentURL: null,
  canceledSubscription: false,
  interests: {
    stats: {},
    list: []
  },
  interestsSearchLoading: false,
  suggestedInterest: {
    interest: {}
  },
  interestError: null,
  selectedInterests: [],
  suggestInterestLoading: false,
  languages: [],
  currencies: [],
  groupsByOrgId: {
    loading: false,
    list: []
  },
  timezone: {
    loading: false,
    value: null,
    list: []
  },
  serverErrors: [],
  userLocation: { latitude: 0, longitude: 0 },
  bannerData: [],
  tagUsersList: [],
  pageMeta: null,
  conversations: {
    list: []
  },
  appVersion: 0,
  enableGDPRCookie: '0',
  forceUpdateUptoAppVersion: {
    android: '8.0',
    ios: '8.0'
  },
  encryptionEnabledFromAppVersion: {
    android: '5.8',
    ios: '5.0'
  },
  gdprEnabledFromAppVersion: {
    android: '6.3',
    ios: '5.3'
  },
  transferRole: {
    loading: false,
    error: '',
    data: null,
    users: {
      list: [],
      stats: null
    }
  },
  gdpr: {
    loading: false,
    success: false,
    settings: null
  }
}

export function common(state = initialStates, action) {
  const { response } = action
  switch (action.type) {
    case cc.SET_IS_DESKTOP:
      return {
        ...state,
        isDesktop: action.status
      }
    case cc.SET_IS_NATIVE:
      return {
        ...state,
        isNative: action.status
      }

    case cc.SET_IS_MOBILE:
      return {
        ...state,
        isMobile: action.status
      }

    case cc.SET_IS_TABLET:
      return {
        ...state,
        isTablet: action.status
      }
    case cc.POPIN_OPEN:
      return {
        ...state,
        isPopinOpen: true,
        openedPopinName: action.name
      }
    case cc.POPIN_CLOSE:
      return {
        ...state,
        isPopinOpen: false,
        openedPopinName: ''
      }

    case cc.CLEAR_NOTIFICATION_COUNT:
      return {
        ...state,
        notifications: {
          unread: 0,
          groups: [],
          mixrs: [],
          items: {}
        }
      }

    case cc.UPDATE_BANNER_DATA: {
      if (action.bannerData) {
        const existingBannerData = state.bannerData.find((x) => x.id === action.bannerData.id)
        //existing banner data will come from post feed with files, where we update banner content on each stage of feed file upload
        if (existingBannerData) {
          const updatedData = state.bannerData.map((banner) => {
            if (banner.id === action.bannerData.id) {
              return action.bannerData
            }
            return banner
          })
          return {
            ...state,
            bannerData: updatedData
          }
        } else {
          return {
            ...state,
            bannerData: [...state.bannerData, { ...action.bannerData, id: action.bannerData.id || uuid() }]
          }
        }
      } else {
        return {
          ...state
        }
      }
    }

    case cc.CLOSE_BANNER_DATA: {
      const bannerId = action.bannerId
      const updatedBannerData = state.bannerData.filter((banner) => banner.id != bannerId)
      return {
        ...state,
        bannerData: updatedBannerData
      }
    }

    case sc.UPDATE_PLAN_SUCCESS:
      return {
        ...state,
        isPopinOpen: true,
        openedPopinName: 'successful-update',
        subscription: {
          ...action.response.responseSubscription,
          rules: {
            userLimit: JSON.parse(action.response.responseSubscription.plan.rules).user_limit,
            workplaceLimit: JSON.parse(action.response.responseSubscription.plan.rules).workplace_limit
          }
        }
      }

    // counter message
    case cc.COUNTER_MESSAGE_REQUEST:
      return {
        ...state
      }
    case cc.COUNTER_MESSAGE_SUCCESS:
      return {
        ...state,
        messages: {
          unread: action.response && action.response.count,
          items: {}
        }
      }

    // failures
    case cc.COUNTER_MESSAGE_FAILURE:
      return {
        ...state
      }

    // counter notif
    case cc.COUNTER_NOTIF_REQUEST:
      return {
        ...state
      }
    case cc.COUNTER_NOTIF_SUCCESS:
      return {
        ...state,
        notifications: {
          unread: action.response && action.response.count,
          items: {},
          ...action.response
        }
      }

    // failures
    case cc.COUNTER_NOTIF_FAILURE:
      return {
        ...state
      }

    // subscribe newsletter
    case cc.LANDING_FORM_REQUEST:
      return {
        ...state,
        landing: {
          submitted: true,
          success: false,
          error: false
        }
      }
    case cc.LANDING_FORM_SUCCESS:
      return {
        ...state,
        landing: {
          submitted: false,
          success: true,
          error: false
        }
      }

    // failures
    case cc.LANDING_FORM_FAILURE:
      return {
        ...state,
        landing: {
          submitted: false,
          success: false,
          error: true
        }
      }

    // Get Invitations - accepted
    case cc.GET_SUBSCRIPTION_REQUEST:
      return { ...state }
    case cc.GET_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        subscription: {
          ...action.response,
          rules: {
            userLimit: action.response && JSON.parse(action.response.plan.rules).user_limit,
            workplaceLimit: action.response && JSON.parse(action.response.plan.rules).workplace_limit
          }
        }
      }
    case cc.GET_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        subscription: {
          rules: {
            userLimit: 0,
            workplaceLimit: 0
          }
        }
      }

    // Get manage payment URL - accepted
    case cc.GET_PAYMENTMANAGEURL_REQUEST:
      return { ...state }
    case cc.GET_PAYMENTMANAGEURL_SUCCESS:
      return { ...state, managePaymentURL: action.response }
    case cc.GET_PAYMENTMANAGEURL_FAILURE:
      return { ...state }

    // cancel subscription
    case cc.CANCEL_SUBSCRIPTION_REQUEST:
      return { ...state }
    case cc.CANCEL_SUBSCRIPTION_SUCCESS:
      return { ...state, canceledSubscription: true }
    case cc.CANCEL_SUBSCRIPTION_FAILURE:
      return { ...state }

    case cc.FILES_CREATION_REQUEST:
      return { ...state, fileCreation: { files: null, loadingFile: true, error: false } }
    case cc.FILES_CREATION_SUCCESS:
      return {
        ...state,
        fileCreation: {
          files: action?.response?.files
            ? action.response.files
            : action?.response?.file // in case of duplicate file from file id
            ? [action.response.file]
            : null,
          loadingFile: false,
          error: false
        }
      }
    case cc.FILES_CREATION_FAILURE: {
      return { ...state, fileCreation: { files: null, loadingFile: false, error: true } }
    }

    case cc.FILE_CREATION_REMOVE:
      return { ...state, fileCreation: { file: null, loadingFile: false } }

    case cc.SEARCH_INTEREST_REQUEST:
      return { ...state, interestsSearchLoading: true }

    case cc.SEARCH_INTEREST_SUCCESS:
      let interests = action.response
      if (action.response.stats.nextOffset > 50) {
        interests = { ...action.response, list: [...state.interests.list, ...action.response.list] }
      }

      return { ...state, interests, interestsSearchLoading: false }

    case cc.SEARCH_INTEREST_FAILURE:
      return { ...state, interestsSearchLoading: false }

    case cc.SUGGEST_INTEREST_REQUEST:
      return { ...state, suggestInterestLoading: true }

    case cc.SUGGEST_INTEREST_SUCCESS:
      return { ...state, suggestedInterest: action.response, suggestInterestLoading: false }

    case cc.SUGGEST_INTEREST_FAILURE:
      return { ...state, suggestInterestLoading: false }

    case cc.UPDATE_INTETESTS_AFTER_SELECTION: {
      const { interest, actionType } = action
      if (interest) {
        if (actionType === 'remove') {
          return {
            ...state,
            interests: {
              ...interests,
              list: state.interests.list.filter((i) => i.id !== interest.id)
            }
          }
        } else if (actionType === 'add') {
          return {
            ...state,
            interests: {
              ...interests,
              list: [{ ...interest, selectedForRemoval: false }, ...state.interests.list]
            }
          }
        }
      }
    }
    case cc.UPDATE_SELECTED_INTERESTS: {
      return {
        ...state,
        selectedInterests: action.interests
      }
    }

    case cc.GET_CURRENCIES_REQUEST:
      return { ...state }

    case cc.GET_CURRENCIES_SUCCESS:
      return { ...state, currencies: response.currencies }

    case cc.GET_CURRENCIES_FAILURE:
      return { ...state }
    case cc.GET_LANGUAGES_REQUEST:
      return { ...state }

    case cc.GET_LANGUAGES_SUCCESS:
      return { ...state, languages: response.languages }

    case cc.GET_LANGUAGES_FAILURE:
      return { ...state }

    case cc.GET_GROUPS_BY_ORGID_REQUEST: {
      return {
        ...state,
        groupsByOrgId: {
          loading: true,
          list: []
        }
      }
    }
    case cc.GET_GROUPS_BY_ORGID_SUCCESS: {
      return {
        ...state,
        groupsByOrgId: {
          loading: false,
          list: response && response.list
        }
      }
    }
    case cc.GET_GROUPS_BY_ORGID_FAILURE: {
      return {
        ...state,
        groupsByOrgId: {
          loading: false,
          list: []
        }
      }
    }
    case cc.GET_TIMEZONE_BY_LAT_LONG_REQUEST:
    case cc.GET_TIMEZONES_REQUEST: {
      return {
        ...state,
        timezone: {
          ...state.timezone,
          loading: true
        }
      }
    }
    case cc.GET_TIMEZONE_BY_LAT_LONG_SUCCESS: {
      return {
        ...state,
        timezone: {
          ...state.timezone,
          value: { ...response },
          loading: false
        }
      }
    }
    case cc.GET_TIMEZONE_BY_LAT_LONG_FAILURE:
    case cc.GET_TIMEZONES_FAILURE: {
      return {
        ...state,
        timezone: {
          ...state.timezone,
          loading: false
        }
      }
    }
    case cc.GET_TIMEZONES_SUCCESS: {
      return {
        ...state,
        timezone: {
          ...state.timezone,
          loading: false,
          list: action.response.time_zones
        }
      }
    }

    case cc.SET_TIMEZONE: {
      return {
        ...state,
        timezone: {
          ...state.timezone,
          value: action.timezone
        }
      }
    }
    case cc.CLEAR_TIMEZONE: {
      return {
        ...state,
        timezone: {
          ...state.timezone,
          value: null,
          loading: false
        }
      }
    }

    case cc.START_FILE_PROCESSING: {
      const updatedFiles = state.filesCreation.map((f) => {
        if (f.messageObject.messageId == action.objectId) {
          return {
            ...f,
            loadingFile: action.mode === 'start'
          }
        } else return f
      })
      return {
        ...state,
        filesCreation: updatedFiles
      }
    }

    case cc.CLEAR_FILE_IDS: {
      const updatedFiles = state.filesCreation.filter((f) => f.messageObject.messageId != action.objectId)
      return {
        ...state,
        filesCreation: updatedFiles
      }
    }

    case cc.GET_POPUP_COOKIE_REQUEST:
      return {
        ...state
      }
    case cc.GET_POPUP_COOKIE_SUCCESS:
      return {
        ...state,
        v2AnnouncementStatus:
          action.popupName === 'v2_migration' ? action.response.has_been_displayed : state.v2AnnouncementStatus
      }
    case cc.GET_POPUP_COOKIE_FAILURE:
      return {
        ...state
      }

    case cc.SET_POPUP_COOKIE_REQUEST:
      return {
        ...state
      }
    case cc.SET_POPUP_COOKIE_SUCCESS:
      return {
        ...state,
        v2AnnouncementStatus:
          action.popupName === 'v2_migration' ? action.response.has_been_displayed : state.v2AnnouncementStatus
      }
    case cc.SET_POPUP_COOKIE_FAILURE:
      return {
        ...state
      }
    case cc.GET_USER_LOCATION_REQUEST:
      return {
        ...state
      }
    case cc.GET_USER_LOCATION_SUCCESS: {
      const exisingLocation = state.userLocation
      const newLocation = action.response
      const timeout = appConstantSettings.USER_LOCATION_TIMEOUT / 1440

      setCookie('user_location', JSON.stringify(action.response), timeout)
      if (exisingLocation && newLocation && deepEqual(exisingLocation, newLocation)) {
        return state
      } else {
        return {
          ...state,
          userLocation: {
            ...state.userLocation,
            ...action.response
          }
        }
      }
    }
    case cc.GET_USER_LOCATION_FAILURE:
      return {
        ...state
      }

    case cc.SET_USER_LOCATION: {
      const exisingLocation = state.userLocation
      const newLocation = action.location
      const timeout = appConstantSettings.USER_LOCATION_TIMEOUT / 1440
      setCookie('user_location', JSON.stringify(action.location), timeout) //set the user location in cookie for 15 minutes
      if (exisingLocation && newLocation && deepEqual(exisingLocation, newLocation)) {
        return state
      } else {
        return {
          ...state,
          userLocation: {
            ...state.userLocation,
            ...action.location
          }
        }
      }
    }

    case cc.SET_USER_APP_VERSION:
      return {
        ...state,
        appVersion: action.version
      }
    case cc.GET_TAG_USERS_REQUEST:
      return { ...state }

    case cc.GET_TAG_USERS_SUCCESS:
      return { ...state, tagUsersList: response.users }

    case cc.GET_TAG_USERS_FAILURE:
      return { ...state }

    case cc.ADD_USER_PAGEVIEW_REQUEST:
      return { ...state }

    case cc.ADD_USER_PAGEVIEW_SUCCESS:
      return { ...state, pageMeta: action.response }

    case cc.ADD_USER_PAGEVIEW_FAILURE:
      return { ...state }

    case cc.GET_CONVERSATIONS_LIST_SUCCESS:
      return {
        ...state,
        conversations: {
          ...state.conversations,
          ...action.data
        }
      }

    case cc.GET_MEMBERS_TO_TRANSFER_GROUP_REQUEST: {
      const { isPagination, search } = action.response
      return {
        ...state,
        transferRole: {
          ...state.transferRole,
          loading: true,
          users: isPagination
            ? state.transferRole.users
            : {
                list: [],
                stats: null
              }
        }
      }
    }
    case cc.GET_MEMBERS_TO_TRANSFER_GROUP_SUCCESS: {
      const { stats, users, search, isPagination } = action.updatedResponse
      let updatedList = [...state.transferRole.users.list]

      if (isPagination && users) {
        updatedList = [...state.transferRole.users.list, ...users]
      } else if (search.length >= 2 || search.length === 0 || state.transferRole.users.list.length === 0) {
        updatedList = users ? [...users] : []
      }
      return {
        ...state,
        transferRole: {
          ...state.transferRole,
          loading: false,
          users: {
            list: updatedList,
            stats: stats
          }
        }
      }
    }
    case cc.GET_MEMBERS_TO_TRANSFER_GROUP_FAILURE: {
      return {
        ...state,
        transferRole: {
          ...state.transferRole,
          loading: false,
          error: action.error
        }
      }
    }
    case cc.SET_TRANSFER_ROLE_DATA: {
      return {
        ...state,
        transferRole: {
          ...state.transferRole,
          data: action.data
        }
      }
    }

    case cc.GET_APP_STORE_VERSIONS_SUCCESS: {
      return {
        ...state,
        enableGDPRCookie: action.data.data.enableGDPRCookie
      }
    }

    case cc.GET_GDPR_REQUEST:
    case cc.UPDATE_GDPR_REQUEST:
      return {
        ...state,
        gdpr: {
          ...state.gdpr,
          loading: true
        }
      }
    case cc.GET_GDPR_SUCCESS:
    case cc.UPDATE_GDPR_SUCCESS:
      return {
        ...state,
        gdpr: {
          ...state.gdpr,
          loading: false,
          success: true,
          settings: action.response.settings
        }
      }
    case cc.GET_GDPR_FAILURE:
    case cc.UPDATE_GDPR_FAILURE:
      return {
        ...state,
        gdpr: {
          ...state.gdpr,
          loading: false,
          success: false
        }
      }

    default:
      return state
  }
}
